'use es6';

import { parse } from 'hub-http/helpers/params';
import { useLocation } from 'quartz-routing/react-router';
const FILTER_TYPES = {
  CATEGORY: 'cat',
  SEARCH: 'search',
  SEARCH_USER: 'searchUser',
  SEARCH_ACCOUNTS: 'searchAccounts',
  SORT_BY: 'sortBy',
  ASSIGNED_BY: 'assignedBy',
  AWARD_TYPE: 'awardType',
  LEVEL: 'level',
  DURATION: 'duration',
  CONTENT_TYPE: 'contentType',
  CONTENT_SOURCE: 'contentSource',
  LANGUAGE: 'language',
  TOOLS: 'tools',
  CREATED_BY: 'createdBy',
  MY_PLAYLISTS_TYPE: 'myPlaylistsType',
  SORT_BY_MY_PLAYLISTS: 'sortByMyPlaylists',
  PROGRESS_STATUS: 'progressStatus',
  SORT_BY_RELEVANCE: 'sortBy',
  SORT_BY_ACCESS: 'sortBy'
};
const FILTER_TYPES_OTHER = {
  CATEGORIES: 'cat',
  TOOLS: 'tools',
  SEARCH: 'search'
};
const useFilterParams = () => {
  const location = useLocation();
  const params = parse(location.search.slice(1));
  const paramsSanitized = {};
  Object.keys(params).forEach(param => {
    const allFilterTypes = [...Object.values(FILTER_TYPES), ...Object.values(FILTER_TYPES_OTHER)];
    if (allFilterTypes.includes(param)) {
      paramsSanitized[param] = params[param];
    }
  });
  return paramsSanitized;
};
export default useFilterParams;